module.exports = __webpack_public_path__ + "static/street-lasvegas-edcef6cd3b159691c10d41220b0579bd.png";